import { Injectable, inject } from '@angular/core';
import { collection, query, where, orderBy, getDocs, QueryConstraint, FirestoreDataConverter, DocumentData, QueryDocumentSnapshot } from 'firebase/firestore';
import { FIRESTORE_TOKEN } from '../firebase/firestore.provider';
import type { ArchiveFile } from '../../shared/interfaces';
import type { UserRole } from '../auth/role.model';

const archiveConverter: FirestoreDataConverter<ArchiveFile> = {
  toFirestore(archive: ArchiveFile): DocumentData {
    return archive as DocumentData;
  },
  fromFirestore(snapshot: QueryDocumentSnapshot): ArchiveFile {
    return snapshot.data() as ArchiveFile;
  }
};

@Injectable({
  providedIn: 'root'
})
export class ArchiveService {
  private readonly firestore = inject(FIRESTORE_TOKEN);

  async fetchArchives(role: UserRole | null | undefined, organizationId?: string | null, siteId?: string | null): Promise<ArchiveFile[]> {
    if (!role) {
      return [];
    }

    const constraints: QueryConstraint[] = [];

    if (role !== 'super_admin') {
      if (!organizationId) {
        return []; // super_admin 以外は organizationId が必須
      }
      constraints.push(where('organizationId', '==', organizationId));

      if (role === 'site_manager') {
        if (!siteId) {
          return []; // site_manager は siteId が必須
        }
        constraints.push(where('siteId', '==', siteId));
      }
    }

    const archivesRef = collection(this.firestore, 'archive_files').withConverter(archiveConverter);

    constraints.push(orderBy('targetMonth', 'desc'));

    const q = query(archivesRef, ...constraints);
    const snapshot = await getDocs(q);

    return snapshot.docs.map(doc => doc.data());
  }
}
